import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "../Onboarding.module.scss";
import { getLanguage } from "../../../utils/LocaleUtil";
import Button from "../../../common/components/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const SignUp = (props) => {
  const { t } = useTranslation();
  const { onNextStep, onPreviousStep, userInfo, setUserInfo } = props;

  const [showPasswordAsText, setShowPasswordAsText] = useState(true);
  const [passwordInputType, setPasswordInputType] = useState("password");

  const togglePasswordVisibility = useCallback(() => {
    if (passwordInputType === "password") {
      setPasswordInputType("text");
      setShowPasswordAsText(false);
    } else {
      setPasswordInputType("password");
      setShowPasswordAsText(true);
    }
  }, [passwordInputType, setPasswordInputType, setShowPasswordAsText]);

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h2>{t("sign_in.create_account")}</h2>
      </div>
      <form
        onSubmit={(e) => {
          onNextStep(e, { ...userInfo, language: getLanguage() || "en" });
        }}
      >
        <div className={styles.inputContainer}>
          <label htmlFor="email">{t("sign_in.email")}</label>
          <div id="email" name="email" className={styles.emailText}>
            <span>{userInfo.email} </span>
          </div>
          <div className={styles.inputRow}>
            <div className={styles.inputColumn}>
              <label htmlFor="given-name">{t("sign_in.first_name")}</label>
              <input
                value={userInfo.firstName}
                onChange={(e) => {
                  const firstName = e.target.value;
                  setUserInfo((infos) => ({
                    ...infos,
                    firstName,
                  }));
                }}
                type="text"
                placeholder={t("sign_in.first_name")}
                autoComplete="given-name"
                id="given-name"
                name="given-name"
                required
                autoFocus
              />
            </div>
            <div className={styles.inputColumn}>
              <label htmlFor="family-name">{t("sign_in.last_name")}</label>
              <input
                value={userInfo.lastName}
                onChange={(e) => {
                  const lastName = e.target.value;
                  setUserInfo((infos) => ({
                    ...infos,
                    lastName,
                  }));
                }}
                type="text"
                placeholder={t("sign_in.last_name")}
                autoComplete="family-name"
                id="family-name"
                name="family-name"
                required
              />
            </div>
          </div>

          <label htmlFor="new-password">{t("sign_in.password")}</label>
          <div className={styles.inputPasswordWithEye}>
            <input
              value={userInfo.password}
              onChange={(e) => {
                const password = e.target.value;
                setUserInfo((infos) => ({
                  ...infos,
                  password,
                }));
              }}
              //type="passwordInputType"
              type={passwordInputType}
              placeholder={t("sign_in.password")}
              autoComplete="new-password"
              id="new-password"
              name="new-password"
              //minlength="8"
              pattern="^(?=.{8,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).*$"
              //pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$" //Only char and numbers
              //pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$" //At least one of each

              onInvalid={(e) =>
                e.target.setCustomValidity(t("sign_in.password_validation"))
              }
              onInput={(e) => e.target.setCustomValidity("")}
              required
            />
            {showPasswordAsText ? (
              <VisibilityOffOutlinedIcon
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={togglePasswordVisibility}
              />
            ) : (
              <VisibilityIcon
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={togglePasswordVisibility}
              />
            )}
          </div>

          <div className={styles.inputContinousRow}>
            <input
              //value={userInfo.optNewsletter}
              onChange={(e) => {
                const optNewsletter = e.target.checked;
                setUserInfo((infos) => ({
                  ...infos,
                  optNewsletter,
                }));
              }}
              type="checkbox"
              placeholder={t("sign_in.optNewsletter")}
              //autoComplete="new-passwordInputType"
              id="optNewsletter"
              name="optNewsletter"
              checked={userInfo.optNewsletter}
              //required
            />
            <label htmlFor="optNewsletter">{t("sign_in.optNewsletter")}</label>
          </div>
        </div>
        <div className={styles.actionContainer}>
          <Button type="submit">{t("sign_in.continue")}</Button>
          <Link to="" onClick={(e) => onPreviousStep(e)}>
            {t("onboard.back")}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
